import {
  array,
  custom,
  email,
  forward,
  is,
  maxLength,
  minLength,
  object,
  regex,
  string,
} from 'valibot';

import { RECIPEINTS_EMAIL_SEPARATOR } from './constants';

export const recipientsEmailListSchema = array(
  string(
    [
      email(),
    ],
  ),
  [
    maxLength(6),
  ],
);

export const promotionUrlShareContentSchema = object(
  {
    senderName: string(
      [
        regex(/^[a-zA-Z\s-]+$/),
        minLength(1),
        maxLength(100),
      ],
    ),
    recipientsJoinedEmailList: string(
      [
        minLength(1),
      ],
    ),
    emailMessage: string(),
  },
  [
    forward(
      custom(
        ({ recipientsJoinedEmailList }) => is(
          recipientsEmailListSchema,
          recipientsJoinedEmailList.split(RECIPEINTS_EMAIL_SEPARATOR),
        ),
      ),
      ['recipientsJoinedEmailList'],
    ),
  ],
);
